import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeUserSubscribe } from '~/types';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

type TypeChangeSubscribeParams = {
  allowRecruit: boolean;
  allowNightTime: boolean;
};

type TypeChangeSubscribeResponse = {
  code: string;
  message: string;
  data: TypeUserSubscribe;
};

/** @description 설정 > 문자 수신 동의 여부 변경 */
export const useChangeSubscribe = () => {
  const { mutateAsync } = useMutation({
    mutationFn: (params: TypeChangeSubscribeParams) => {
      const endpoint = '/labor-account/change-subscribe';
      return axiosInstance.put(endpoint, params);
    },
  });

  const requestChangeSubscribe = async ({
    params,
    onSuccess,
    onError,
  }: {
    params: TypeChangeSubscribeParams;
    onSuccess?: (res: TypeChangeSubscribeResponse) => void;
    onError?: (err: TypeErrorFormat) => void;
  }) => {
    requestHelper(() => mutateAsync(params), onSuccess, onError);
  };

  return requestChangeSubscribe;
};
